<template>
  <div class="orderDetail">
    <div class="orderDetail__success">
      <div class="orderDetail__success__top">
        <div class="wrapper-icon">
          <img class="wrapper-icon__icon-img" :src="iconImg" alt="">
        </div>
        <h1 class="title bold medium-title">Order has been sent</h1>
      </div>
      <div class="orderDetail__success__center subhead">
          Our team will contact you soon to validate your order.
      </div>
      <div class="orderDetail__success__bottom">
        <button class="btn-block primary" @click="goHomepage()">Back To Homepage</button>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "adx-order-detail",
  components: {
  },
  data(){
    return {
      iconImg: "/img/icon-checklist.png"
    }
  },
  created() {
  },
  beforeMount() {
  },
  mounted() {
  },
  methods: {
    goHomepage() {
      this.$router.push({name:'home'})
    },
  },
  watch: {
  },
  computed: {
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>
